// EXTERNAL_ERROR_TRANSLATIONS from https://docs.google.com/spreadsheets/d/1VizCowmGczq9495fFduZNWhzLgICsR8bZBsZg-tLacE/edit?gid=0#gid=0
export const EXTERNAL_ERROR_TRANSLATIONS = {
  100: '100: A mensagem possui caracteres ou\nparâmetros incompatíveis com a Meta.\nVerifique a mensagem e tente enviar\nnovamente.',
  130472:
    '130472: Este cliente não recebe\nModelos (Templates) de mensagem de\nMarketing, tente novamente com um\nModelo do tipo Utility.',
  131008:
    '131008: A mensagem foi enviada sem um\ncampo obrigatório. Se for um Modelo\n(Template), confira se todas as variáveis\ne mídias foram preenchidas e tente\nnovamente. Se persistir, contate nosso\nsuporte.',
  131026:
    '131026: Verifique se existe um WhatsApp\ncadastrado neste número. Caso exista, o\ncliente não está atualizado com o WhatsApp\ne não será possível contatá-lo.',
  131042:
    '131042: Problema de pagamento do\nWhatsApp hospedado na Meta. Na página\nde pagamentos da Meta, selecione Contas\nde WhatsApp e veja se há transações\nrecusadas. Caso haja, clique no botão\n`Pagar agora`. Após isso o envio voltará a\nfuncionar em cerca de 3 minutos.  Acesse\npor: business.facebook.com/billing_hub/\npayment_activity',
  131047:
    '131047: Cliente em janela de restrição por ter\npassado mais de 24 horas desde a ultima\nmensagem enviada pelo contato. Atualize a\npágina e envie uma mensagem pelos\nModelos de Mensagem (Templates).',
  131049:
    '131049: A Meta bloqueou o envio da\nmensagem do tipo Marketing para\neste cliente no momento por falta de\nrespostas. Tente esperar 30\nsegundos e enviar um Modelo\n(Template) do tipo Utility.',
  131051:
    '131051: O tipo de mensagem não é\ncompatível. Reveja o conteúdo da\nmensagem e tente novamente.',
  131053:
    '131053: Não foi possível carregar a mídia\nusada na mensagem. A mídia é incompatível\ncom o modelo (template) usado (ex: imagem\nsendo enviada em modelo de pdf) ou então\no tipo ou tamanho da mídia não são\nsuportados pela Meta. Imagens suportadas\nem JPEG e PNG até 5mb. Vídeos suportados\nem 3GPP e MP4 Video até 16mb.',
  135000:
    '135000: Ocorreu um erro desconhecido na\nMeta no envio da mensagem. Contate nosso\nsuporte sobre o ocorrido.',
};

/**
 * Only a code at the very start of the string followed by a colon counts. Other
 * providers write `external_error` in shapes this deliberately ignores, such as
 * Instagram's `"<code> - <message>"` and the plain sentence stored by
 * AtendeTotal::SetWhatsappMessagesWithoutSendConfirmationAsFailedJob.
 *
 * @param {string} string
 * @returns {string | undefined}
 */
export const getErrorCodeToTranslation = string =>
  string?.match(/^(\d+):/)?.[1];

/**
 * @param {string} externalError
 * @returns {string | undefined}
 */
export const translateExternalError = externalError =>
  EXTERNAL_ERROR_TRANSLATIONS[getErrorCodeToTranslation(externalError)];
